// types
import { PlanItem } from 'components/pricing';

import { Feature, CrmFeatures } from './types';

const features: Feature[] = [
    {
        avatar: 'users',
        title: 'Lead Management',
        description:
            `Centralized database for lead storage and tracking.
Automated lead scoring to identify high-priority opportunities.
Capture leads from multiple channels, such as web forms, email, and social media.`,
        variant: 'primary',
        containerClass: 'd-flex  pb-4 ',
    },
    {
        avatar: 'git-merge',
        title: 'Sales Pipeline Management',
        description: `Visual pipeline for tracking deals across different stages.
Drag-and-drop functionality to update deal status easily.
Notifications and reminders for follow-ups and task deadlines.`,
        variant: 'success',
        containerClass: 'd-flex  pb-4',
    },
    {
        avatar: 'activity',
        title: 'Activity Tracking',
        description: `Logs every interaction with customers (calls, emails, meetings).
Calendar integration for scheduling follow-ups.
Email sync to track communication and set automated responses.`,
        variant: 'orange',
        containerClass: 'd-flex pb-4',
    },
    {
        avatar: 'bar-chart-2',
        title: 'Reporting and Analytics',
        description: `Pre-built and customizable reports for sales trends and performance.
Conversion tracking for leads and deals.
Insights into lead sources and ROI from campaigns.`,
        variant: 'orange',
        containerClass: 'd-flex pb-4',
    },
    {
        avatar: 'message-circle',
        title: 'Collaboration Tools',
        description: `Shared notes, documents, and updates for better team collaboration.
Role-based access controls to manage data security.
Chat and task assignment features for seamless communication.`,
        variant: 'orange',
        containerClass: 'd-flex pb-4',
    },
    {
        avatar: 'sliders',
        title: 'Customization',
        description: `Tailor fields, workflows, and pipelines to match your sales process.`,
        variant: 'orange',
        containerClass: 'd-flex pb-4',
    },
];

const crmFeatures: CrmFeatures[] = [
    {
        title: "Customer Lifecycle",
        features: ["Lead Management", "Opportunity Tracking", "Customer Profiles", "Vendor Management"],
        icon: "🧩",
    },
    {
        title: "Engagement Tools",
        features: ["Run email campaigns", "Capture leads via smart forms", "Automated Follow-ups"],
        icon: "💬",
    },
    {
        title: "Operations",
        features: ["Projects", "Timesheets", "Task Management",],
        icon: "🛠",
    },
    {
        title: "Financials",
        features: ["Invoices", "Quotations", "Expense Tracking", "Purchase Orders", "Sales Orders", "Products"],
        icon: "💰",
    },
    {
        title: "Analytics & Reports",
        features: ["Custom Reports", "Dashboards", "Forecasting", "Data Import", "Data Export"],
        icon: "📊",
    },
];

const plans: PlanItem[] = [
    {
        id: 1,
        name: 'Starter',
        price: '49',
        duration: '/ month',
        features: [
            'Up to 600 minutes usage time',
            'Use for personal only',
            'Add up to 10 attendees',
            '1 User',
            'Technical support via email',
        ],
        isRecommended: false,
        allowedTrialDays: 1
    },
    {
        id: 2,
        name: 'Professional',
        price: '99',
        duration: '/ month',
        features: [
            'Up to 6000 minutes usage time',
            'Use for personal or a commercial',
            'Add up to 100 attendees',
            'Up to 5 teams',
            'Technical support via email',
        ],
        isRecommended: true,
        allowedTrialDays: 1
    },
    {
        id: 3,
        name: 'Enterprise',
        price: '599',
        duration: '/ month',
        features: [
            'Unlimited usage time',
            'Use for personal or a commercial',
            'Add Unlimited attendees',
            '24x7 Technical support via phone',
            'Technical support via email',
        ],
        isRecommended: false,
        allowedTrialDays: 1
    },
];

export { features, plans, crmFeatures };
